import { render, staticRenderFns } from "./CustomerLst.vue?vue&type=template&id=6fd68bf2&"
import script from "./CustomerLst.vue?vue&type=script&lang=js&"
export * from "./CustomerLst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CustomerLst.vue"
export default component.exports